import { ArrowUpRight, Command, Download, Menu, X } from 'lucide-react';
import { useState } from 'react';
import type { WorldKind } from '@core/types';
import { routeTo } from '../lib';
import { Logo } from './Logo';

export function TopNav({ world, compact = false }: { world: WorldKind; compact?: boolean }): JSX.Element {
  const [open, setOpen] = useState(false);
  const items = world === 'pink'
    ? [['stage', 'STAGE'], ['companion', 'COMPANION'], ['blueprint', 'SPECIES']] as const
    : [['lab', 'LAB'], ['companion', 'HABITAT'], ['blueprint', 'SYSTEM']] as const;
  return <header className={`top-nav ${compact ? 'compact' : ''}`}>
    <Logo />
    <div className="nav-world"><span className={`world-dot ${world}`} />{world === 'pink' ? 'PUBLIC STAGE' : 'PRIVATE LAB'}</div>
    <nav className={open ? 'nav-links open' : 'nav-links'} aria-label="Primary">
      {items.map(([path, label]) => <button key={path} onClick={() => { routeTo(`/${path}`); setOpen(false); }}>{label}</button>)}
      <button className="nav-download" onClick={() => routeTo('/download')}><Download size={13} /> DESKTOP <ArrowUpRight size={13} /></button>
    </nav>
    <div className="nav-actions">
      <span className="command-hint"><Command size={12} /> K</span>
      <button className="icon-button menu-button" onClick={() => setOpen(!open)} aria-label="Toggle menu">{open ? <X size={17} /> : <Menu size={17} />}</button>
    </div>
  </header>;
}
